import { useMemo, useState } from "react"
import PropTypes from "prop-types"
import { map, size } from "lodash"
import { AppBar, Toolbar, Typography, Drawer, ListSubheader, List } from "@mui/material"
import MetricsSearch from "components/metrics-selector/metrics-search"
import MetricsCategory from "./metrics-category"
import { AvailableMetricsShape } from "./helpers/prop-types"
import { getFilteredMetrics } from "./helpers"
import "./styles.scss"

const MAX_COLUMNS = 20

export default function MetricSelector({
  isOpen,
  toggle,
  selectedMetrics,
  availableMetrics,
  includeMetricTypes = false,
  setSelectedMetrics,
}) {
  const [metricsSearchValue, setMetricsSearchValue] = useState("")
  const selectedMetricCount = size(selectedMetrics)
  const disableOptions = selectedMetricCount >= MAX_COLUMNS

  const filteredMetrics = useMemo(() =>
    getFilteredMetrics(availableMetrics, selectedMetrics, metricsSearchValue),
  [availableMetrics, selectedMetrics, metricsSearchValue],
  )

  return <Drawer
    anchor="right"
    open={isOpen}
    onClose={toggle}
    classes={{
      root: "components_metrics-selector",
      paper: "metrics-selector-drawer",
    }}
  >
    <AppBar position="sticky">
      <Toolbar>
        <Typography variant="h6" color="inherit" noWrap>
          {`Metrics Selected (${selectedMetricCount}/${MAX_COLUMNS})`}
        </Typography>
      </Toolbar>
    </AppBar>
    <div className="metrics-selector-wrapper">
      <MetricsSearch
        metricsSearchValue={metricsSearchValue}
        setMetricsSearchValue={setMetricsSearchValue}
      />
      <div className="metrics-selector-list">
        {map(filteredMetrics, categoryGroup => {
          if (!categoryGroup.categories) {
            return null
          }
          return <List
            key={categoryGroup.id}
            className="metrics-category-group"
            subheader={categoryGroup.label && <ListSubheader className="category-header">
              {categoryGroup.label}
            </ListSubheader>}
          >
            {map(categoryGroup.categories, category => category?.subcategories && <MetricsCategory
              key={`${categoryGroup.id}-${category.label || category.category}`}
              category={category}
              disableOptions={disableOptions}
              setSelectedMetrics={setSelectedMetrics}
              selectedMetrics={selectedMetrics}
              includeMetricTypes={includeMetricTypes}
              metricsSearchValue={metricsSearchValue}
            />)}
          </List>
        })}
      </div>
    </div>
  </Drawer>
}

MetricSelector.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  availableMetrics: AvailableMetricsShape,
  setSelectedMetrics: PropTypes.func.isRequired,
  selectedMetrics: PropTypes.objectOf(PropTypes.bool).isRequired,
  includeMetricTypes: PropTypes.bool,
}
